import { Quote } from "../../components";
import { useAppContext } from "../../context/app-context";

export const QuoteOptionsScreen = () => {
  const { options, setOptions } = useAppContext();

  return (
    <div>
      <div className="tw-text-center tw-my-5 md:tw-my-14">
        <h1 className="tw-text-2xl md:tw-text-4xl tw-text-blue tw-font-bold">
          Our recommendations for you
        </h1>
        <p className="tw-mt-4 tw-text-blue tw-text-sm md:tw-text-lg">
          Based on the information you shared with us, we recommend these
          product bundles to efficiently heat and cool your home. These prices
          are estimates only - one of our product specialists will review and
          finalize your price with you, and confirm your eligibility for
          available incentives. All prices shown below include the applicable provincial sales tax.
        </p>
      </div>
      <div className="tw-space-y-12">
        {options.map((option, index) => (
          <Quote
            key={index}
            option={option}
            onChange={(option) =>
              setOptions((prev) =>
                prev.map((prevOption) =>
                  prevOption.rank === option.rank ? option : prevOption
                )
              )
            }
          />
        ))}
      </div>
      <div className="tw-text-center tw-text-[10px] tw-mt-5 tw-mb-2">
        * On approved credit by Financeit Canada Inc.{" "}
        <a
          className="tw-underline"
          href="https://1clickenergy.com/pages/terms-and-conditions"
          target="_blank"
        >
          Terms and Conditions
        </a>{" "}
        apply.
      </div>
    </div>
  );
};
